import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { PublicClientApplication } from "@azure/msal-browser"; // Import MSAL
import { msalConfig } from "../auth/msalConfig"

const baseUrl = process.env.REACT_APP_BACKEND_BASE_URL;

const myApi = axios.create({
  baseURL: baseUrl,
  headers: {
    "Content-Type": "application/json",
  },
});

const msalInstance = new PublicClientApplication(msalConfig);

const initializeMsal = async () => {
  try {
    await msalInstance.initialize();
  } catch (error) {
    console.error("Error initializing MSAL:", error);
  }
};

const getAccessToken = async () => {
  try {
    await initializeMsal();
    const accounts = msalInstance?.getAllAccounts?.();
    const account = accounts ? accounts[0] : null;
    if (!account) {
      msalConfig.logoutRedirect({
        postLogoutRedirectUri: window.location.origin,
      });
      return null;
    }
    msalInstance?.setActiveAccount(account);
    const tokenRequest = {
      scopes: [`${process.env.REACT_APP_CLIENT_ID}/.default`],
    };
    const response = await msalInstance?.acquireTokenSilent(tokenRequest);
    return response?.accessToken;
  } catch (error) {
    console.error("Error acquiring token:", error);
    msalConfig.logoutRedirect({
      postLogoutRedirectUri: window.location.origin,
    });
    return null;
  }
};

export const createApi = (endpoint, method) => {
  return createAsyncThunk(
    `api/${endpoint}`,
    async (payload = {}, { rejectWithValue }) => {
      const { params, data, dynamicEndpoint, headers, ...rest } = payload || {};
      let url;
      let config;
      try {
      const accessToken = await getAccessToken();
        const userEmail = localStorage.getItem("data");
  //      const LTRole = localStorage.getItem("LTRole");
  //      const CDRole = localStorage.getItem("CDRole");
  //      const LTRegion = localStorage.getItem("LTRegion");
        if (!accessToken) {
          throw new Error("Failed to get access token");
        }

    //    const updatedParams = {
    //      ...params,
    //      userEmail,
    //      ltRole: LTRole,
    //      cdRole: CDRole,
    //      ltRegion: LTRegion
    //    };
    

        // Build request URL. If a dynamicEndpoint is provided use it (it may include querystring),
        // otherwise use the configured endpoint.
        if (dynamicEndpoint) {
          url = dynamicEndpoint.startsWith("http")
            ? dynamicEndpoint
            : `${baseUrl}/${dynamicEndpoint}`;
        } else {
          url = `${baseUrl}/${endpoint}`;
        }

        // Build axios config. For GET requests prefer `params` (query string) and avoid sending a body.
        config = {
          method: method.toLowerCase(),
          url,
          headers: {
            ...(headers || {}),
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
        };

        if (method === "GET") {
          if (params && Object.keys(params).length) {
            config.params = params;
          } else if (data && typeof data === "object" && Object.keys(data).length) {
            // sometimes callers pass query values in `data` for GET; treat them as params
            config.params = data;
          } else if (!params && !data && rest && Object.keys(rest).length) {
            // callers may pass the payload directly (unwrapped); treat remaining keys as params
            config.params = rest;
          }
        } else {
          // For non-GET methods send the payload as body when provided
          if (data !== undefined) {
            config.data = data;
          } else if (!data && !params && rest && Object.keys(rest).length) {
            // If caller dispatched an unwrapped payload (e.g. dispatch(apiAction(payload)))
            // treat the remaining keys as the request body for POST/PUT etc.
            config.data = rest;
          }

          // Support legacy pattern where dynamicEndpoint is path segment for PUT/DELETE
          if ((method === "PUT" || method === "DELETE") && dynamicEndpoint && !dynamicEndpoint.startsWith("http")) {
            // if dynamicEndpoint is just an id or subpath, ensure it's appended
            if (!dynamicEndpoint.includes("?")) {
              // if url was built from endpoint earlier, append dynamicEndpoint
              if (!url.includes(dynamicEndpoint)) {
                config.url = `${baseUrl}/${endpoint}/${dynamicEndpoint}`;
              }
            }
          }
        }

        const response = await myApi.request(config);

        return response?.data;
      } catch (error) {
        console.error("API request failed", {
          url,
          message: error?.message,
          request: error?.request,
        });
        return rejectWithValue(error?.response?.data || error?.message);
      }
    }
  );
};